import { Session } from '../lib-admin';
import {
  Code,
  CredentialEnum,
  OrganizationPolicy,
  PolicyName,
  RuleName,
  RuleParams,
  SecurityGroupName,
  SecurityGroupOveride,
  TimeEnum,
} from '@orgbrain/lib-data';
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-var */

import { PermissionEnum, permissionDescription } from '@orgbrain/roles';
import { PreemptiveSecurityReport } from '../classes';
import { Auth } from '..';

// eslint-disable-next-line prefer-const
export let latency = 0; // adjust rules so that they are leaneant with this amount of minutes.

export type AuthError = {
  message: string;
  authcode: Code;
  result?: Auth.RuleResult;
  canRetry?: boolean;
};

export function Deny({ message, authcode, result, canRetry }: AuthError) {
  const error = {
    message,
    authcode,
    result,
    canRetry,
  };
  return error;
}

// export type PermissionWithAnyEnum = PermissionEnum | 'DEFAULT';

export type AtomicRuleMap = { [key: string]: AtomicRule };

// export type Explination = {
//   pass?: boolean;
//   type: ExplinationTypeEnum;
//   description?: { en: string; nb: string };
//   children?: any[];
// };

// export type PolicyExplination = {
//   filteredRules?: { [group in SecurityGroupName]?: SecurityGroupRule };
//   pass?: boolean;
//   policy?: Policy;
// };

export type RuleEvaluateArgs = {
  session: Session;
  params: RuleParams;
  preemptiveReport: PreemptiveSecurityReport; /// Caution this is not in backend  so we may wnat to refactor to make the flow less convoluted.
};

export class RuleResult {
  pass: boolean;
  mfaCredentialsRequired?: CredentialEnum[];
  idMethodsRequired?: CredentialEnum[];
  ruleName?: RuleName; // For debugging
  perm?: PermissionEnum; // For debugging
  reason?: string; // For debugging
  expires: number; // when rule will expire 0 means never
  credExpires?: { [key in CredentialEnum]?: number }; // raw credential will expire
  assertLoginCredentials?: CredentialEnum[]; // Alternatives for require Session credentials.  NO time limit. Used to assert user has logged in with one of these credentials
}
export interface Rule {
  description: { en: string; nb: string };
  evaluate: (args: RuleEvaluateArgs) => RuleResult;
  params?: RuleParams;
}

export interface AtomicRuleImplemention {
  evaluateFunc: (args: RuleEvaluateArgs) => RuleResult;
}

export type SecurityGroupRule = {
  securityGroupName: SecurityGroupName;
  ruleName: RuleName;
  params?: RuleParams;
  pass?: boolean;
};

export type SecurityGroupRuleMap = { [key in SecurityGroupName]: SecurityGroupRule };

export class AtomicRule implements Rule {
  constructor(
    public name: RuleName,
    public description: { en: string; nb: string },
    public impl: AtomicRuleImplemention[], //  evaluate in order until a fail then return the fail result.   If all pass return the last result
    public params: RuleParams
  ) {}

  evaluate(args: RuleEvaluateArgs): RuleResult {
    let result;
    for (const impl of this.impl) {
      result = impl.evaluateFunc(args);
      if (!result.pass) {
        return result;
      }
    }
    return result;
  }
}

type PermissionSecurityGroupMap = { [perm in PermissionEnum]: SecurityGroupName };

export type Policy = {
  name: string;
  description: { en: string; nb: string };
  securityGroupRuleMap: SecurityGroupRuleMap;
  permissionSecurityGroupMap?: PermissionSecurityGroupMap; // default permission security group map  this will be built from the default permission security group map and organization overrides
  overrides?: SecurityGroupOveride; // override params for a security group for the user gotten from the organizationPolicy
};

export type ProtoPolicyMap = { [name in PolicyName]: Policy };

// export const _defaultOrgPolicy: OrganizationPolicy = {
//   cannedPolicyName: PolicyName.Default,
//   overrides: undefined,
//   permisionSecurityGroupOverrideMap: undefined,
//   assertLoginCredentials: undefined,
// };

export function getDefaultOrgPolicy(): OrganizationPolicy {
  return {
    cannedPolicyName: PolicyName.Default,
    overrides: undefined,
    permisionSecurityGroupOverrideMap: undefined,
    assertLoginCredentials: undefined,
  };
}

export const defaultPermissionSecurityGroup: PermissionSecurityGroupMap = {} as any;

for (const [key, val] of Object.entries(permissionDescription)) {
  defaultPermissionSecurityGroup[key as PermissionEnum] = val.defaultSecurityLevel;
}
